import { render, staticRenderFns } from "./OfficeSection.vue?vue&type=template&id=5fb6a47a&scoped=true&"
import script from "./OfficeSection.vue?vue&type=script&lang=js&"
export * from "./OfficeSection.vue?vue&type=script&lang=js&"
import style0 from "./OfficeSection.vue?vue&type=style&index=0&id=5fb6a47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb6a47a",
  null
  
)

export default component.exports